import React, { useEffect, useState } from "react";
import { Box, Button, Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";

// Componentes
import PlansDataTable from "./PlansDataTable";
import { deletePlan, getPlans } from "../../../../controllers/company/subscriptions/PlansController";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import SectionTitle from "../../../../components/sectionTitle";
import QUDProgress from "../../../../components/progress";
import ResponseComponent from "../../../../components/responseComponent";

// Controlador


export default function Plans() {
    const theme = useTheme();
    const history = useHistory();
    
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [show,setShow] = useState(false);
    const [success,setSuccess] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [actionText,setActionText] = useState('Finalizar');
    const [secondaryText,setSecondaryText] = useState('SI');

    // Carga inicial
    useEffect(() => {
        fetchPlans();
    }, []);

    const fetchPlans = async () => {
        setIsLoading(true);
        const response = await getPlans();
        if (response.success) {
            setPlans(response.data);
        }
        setIsLoading(false);
    };

    const handleDeletePlan = async (id) => {
        // Aquí podrías poner un SweetAlert o confirmación antes

        setIsLoading(true);
        const response = await deletePlan(id);
        if (response.success) {
            // Actualización optimista del estado local
            setPlans(prev => prev.filter(p => p.id !== id));

            setSuccess(true);
            setTitle('Operación Exitosa');
            setMessage('Plan eliminado correctamente');
            setShow(true);

        } else {
            //Manejar el ResponseComponent
            setSuccess(false);
            setTitle('Operación Fallida');
            setMessage('No se pudo eliminar el plan. Verifica que no tenga suscriptores activos.');
            setShow(true);
        }
        setIsLoading(false);
    };

    return (
        <Container maxWidth='xl'>
            <CustomBreadcrumbs 
                returnTo='/dashboard' 
                crumbs={[
                    { name: 'Dashboard', link: '/dashboard' },
                    { name: 'Suscripciones', link: '/subscriptions' },
                    { name: 'Planes', link: '/subscriptions/plans' }
                ]}
            />
            
            <br/>
            <SectionTitle title='Planes de Suscripción' subtitle={'(Gestión)'} />

            {/* Header con Información y Botón Agregar */}
            <Grid container spacing={3} alignItems="center" sx={{ mb: 3 }}>
                <Grid item xs={12} lg={8}>
                    <Paper elevation={3} sx={{ p: 2, backgroundColor: '#ebf9ff', display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ mr: 2, color: theme.palette.primary.main }}>
                            <FontAwesomeIcon icon={faClipboardList} size="2x" />
                        </Box>
                        <Box>
                            <Typography variant="h6" color="primary" gutterBottom>
                                Gestiona tus Servicios Recurrentes
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Crea planes para que tus clientes se suscriban (ej. Mensualidades, Trimestres).
                                Desde aquí podrás ver quién está inscrito en cada plan.
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
                
                <Grid item xs={12} lg={4} display="flex" justifyContent="flex-end">
                    <Button
                        variant='contained'
                        size="large"
                        endIcon={<AddCircleIcon />}
                        onClick={() => history.push('/subscriptions/plans/create')}
                    >
                        Crear Nuevo Plan
                    </Button>
                </Grid>
            </Grid>

            {/* Tabla de Planes */}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper elevation={2}>
                        <PlansDataTable 
                            plans={plans} 
                            onDeletePlan={handleDeletePlan}
                            isLoading={isLoading}
                        />
                    </Paper>
                </Grid>
            </Grid>

            <QUDProgress open={isLoading} />

            <ResponseComponent
                title={title}
                show={show}
                success={success}
                message={message}
                actionText={'Aceptar'}
                onClick={()=>setShow(false)}
            />
        </Container>
    );
}